var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useToken } from './useToken';
import { useClientId } from './useClientId';
import { O, pipe } from '../lib/EffectExports';
import { CHAT_BOT_TOKEN_HEADER, LINE_OF_BUSINESS_HEADER, } from '../constants/headers';
import { useCallback, useMemo } from 'react';
import { GraphQLClient } from 'graphql-request';
import { AUTH_ENDPOINT, UNAUTH_ENDPOINT } from '../constants/endpoints';
import { useLineOfBusiness } from './useLineOfBusiness';
import { getToken } from '../graphql/authentication';
import { CHAT_BOT_SCOPES } from '../constants/authScopes';
const getGraphQLClientWithChatBotToken = (lineOfBusiness, token, chatBotToken) => {
    return new GraphQLClient(O.isSome(token) ? AUTH_ENDPOINT : UNAUTH_ENDPOINT, {
        credentials: 'include',
        headers: Object.assign(Object.assign({ [LINE_OF_BUSINESS_HEADER]: lineOfBusiness }, pipe(token, O.map(tok => ({ authorization: `Bearer ${tok}` })), O.getOrElse(() => ({})))), pipe(chatBotToken, O.map(tok => ({ [CHAT_BOT_TOKEN_HEADER]: tok })), O.getOrElse(() => ({})))),
    });
};
const useGQLClientWithTokenOptionsDefault = {
    includeBotToken: true,
};
const useGQLClientWithToken = (lineOfBusiness, clientId, options = {}) => {
    const { includeBotToken } = Object.assign(Object.assign({}, useGQLClientWithTokenOptionsDefault), options);
    const { token } = useToken(clientId);
    const client = useMemo(() => __awaiter(void 0, void 0, void 0, function* () {
        return getGraphQLClientWithChatBotToken(lineOfBusiness, yield token, includeBotToken ? yield getToken(clientId, CHAT_BOT_SCOPES) : O.none());
    }), [clientId, includeBotToken, lineOfBusiness, token]);
    return client;
};
export const useRequestWithClientId = (includeBotToken, lineOfBusiness, clientId, document, ...[variables]) => {
    const client = useGQLClientWithToken(lineOfBusiness, clientId, {
        includeBotToken: includeBotToken,
    });
    return useCallback((...[vars]) => __awaiter(void 0, void 0, void 0, function* () {
        return (yield client).request({
            document,
            variables: Object.assign(Object.assign({}, (variables !== null && variables !== void 0 ? variables : {})), (vars !== null && vars !== void 0 ? vars : {})),
        });
    }), [client, document, variables]);
};
export const useRequest = (document, ...[variables]) => {
    const { clientId } = useClientId();
    const { lineOfBusiness } = useLineOfBusiness();
    return useRequestWithClientId(false, lineOfBusiness, clientId, document, variables);
};
//# sourceMappingURL=useRequest.js.map